import axios from '@/utils/api'
import rotas from '@/constants/rotas'

const actions = {
  calculoIntersectGeo ({ commit }, data) {
    return axios({
      method: 'post',
      data,
      url: rotas.ARRECADACAO.CALCULO_INTERSECT_GEO,
      loader: false,
      error: true
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/arrecadacao/geo.js